import { connect } from 'react-redux';

import { cancel } from 'src/actions';
import { replaceVideoActions } from 'src/dashboard/state/replace-video/replace-video-actions';
import { videoPrivacyActions } from 'src/dashboard/state/video-privacy/video-privacy-actions';
import { shouldExposeVideoPrivacyChange } from 'src/utils/selectors/should-expose-video-privacy-change';

import { VideoFooterComponent } from './video-footer-component';

const mapStateToProps = (state) => ({
  shouldExposeVideoPrivacyChange: shouldExposeVideoPrivacyChange(state),
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  cancelVideo: () => dispatch(cancel(ownProps.video, 'footer')),
  handlePrivacyClick: (shouldExposeVideoPrivacyChange) => {
    if (shouldExposeVideoPrivacyChange) {
      dispatch(
        videoPrivacyActions.videoFooter.privacyItem.clicked(
          ownProps.video.shortcode
        )
      );
    } else {
      ownProps.togglePrivacyModal();
    }
  },
  handleReplaceClick: (shortcode) =>
    dispatch(replaceVideoActions.videoFooter.replaceItem.clicked(shortcode)),
});

export const VideoFooterContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(VideoFooterComponent);
